module.exports = __webpack_public_path__ + "assets/media/favicon128.39fe8685b9a14829bbb937440bcb527d.png";